// Blueprint: forge/blueprint/frontend/architecture/001-shell-composition.md
import { observer } from 'mobx-react';
import { useDependencies } from '@servicetitan/react-ioc';
import { Button, Flex, Text } from '@servicetitan/anvil2';
import IconArrowForward from '@servicetitan/anvil2/assets/icons/material/round/arrow_forward.svg';

import { AuthStore } from '../common/stores/auth.store';

import sidebarSvg from '../common/assets/sidebar.svg';
import STLogo from '../common/assets/st-logo.svg?component';

import * as Styles from './auth-module.module.scss';

export const AuthModule = observer(() => {
    /*
     * Both entry points are driven by the AuthStore: `loginWithEH`/`loginWithST` perform the top-level
     * navigation to the BFF login endpoint. The component mirrors Header/Sidebar — an observer that pulls
     * its action surface straight from the store rather than receiving callbacks as props. The split
     * brand-panel layout mirrors the ServiceTitan sign-in surface shared by Contact Center Pro and authz.
     */
    const [{ loginWithEH, loginWithST }] = useDependencies(AuthStore);

    return (
        <div className={Styles.signinPageContainer}>
            <div className={Styles.sidebarContainer}>
                <img src={sidebarSvg} className={Styles.sidebarSvg} alt="" />
            </div>
            <div className={Styles.signinPageContent}>
                <STLogo className={Styles.stLogo} />
                <Flex direction="column" gap="3">
                    <div>
                        <Text variant="headline" el="h1" size="medium">
                            Welcome to Org Hub
                        </Text>
                    </div>
                    <Text className={Styles.noWrapText}>Sign in using your credentials.</Text>
                    {/* Org Hub keeps both sign-in entry points (as today); stacked full-width to
                        match the single-button footprint of the reference design without truncating the
                        longer labels. */}
                    <Flex direction="column" gap="2">
                        <Button
                            className={Styles.signinBtn}
                            appearance="secondary"
                            icon={{ after: IconArrowForward }}
                            onClick={loginWithEH}
                            data-testid="login-eh-button"
                        >
                            Sign in with Enterprise Hub
                        </Button>
                        <Button
                            className={Styles.signinBtn}
                            appearance="secondary"
                            icon={{ after: IconArrowForward }}
                            onClick={loginWithST}
                            data-testid="login-st-button"
                        >
                            Sign in with ServiceTitan
                        </Button>
                    </Flex>
                </Flex>
            </div>
        </div>
    );
});
